import React from 'react';

export const LOGO_URL = '/img/k9os-logo.png';

export const Logo = ({ size = 40, className = '', showText = true }) => (
  <div className={`flex items-center gap-2 sm:gap-3 min-w-0 ${className}`}>
    <img
      src={LOGO_URL}
      alt='K9os App'
      width={size}
      height={size}
      className='rounded-md object-cover shadow-sm shrink-0 w-7 h-7 sm:w-10 sm:h-10'
      data-testid='brand-logo'
    />
    {showText && (
      <div className='leading-tight min-w-0'>
        <div className='font-display font-bold text-[13px] sm:text-[15px] tracking-tight text-[#0B1220] dark:text-slate-50 whitespace-nowrap'>K9os App</div>
        <div className='hidden sm:block text-[10px] font-semibold tracking-[0.16em] uppercase text-[#1B3A87] dark:text-[#93C5FD] whitespace-nowrap'>All-in-One Dog Trainer System</div>
      </div>
    )}
  </div>
);

export const ShieldOutline = ({ className = '' }) => (
  <svg viewBox='0 0 100 120' className={className} aria-hidden>
    <path d='M50 4 L92 18 V58 C92 86 70 110 50 116 C30 110 8 86 8 58 V18 Z' fill='none' stroke='currentColor' strokeWidth='1.5' />
  </svg>
);
